import { useSyncExternalStore } from "react";
import { BREAKPOINTS } from "./tokens";

/** 订阅一个媒体查询 */
export function useMediaQuery(query: string, ssr = false): boolean {
  return useSyncExternalStore(
    (cb) => {
      if (typeof matchMedia !== "function") return () => {};
      const mq = matchMedia(query);
      mq.addEventListener?.("change", cb);
      return () => mq.removeEventListener?.("change", cb);
    },
    () => (typeof matchMedia === "function" ? matchMedia(query).matches : ssr),
    () => ssr,
  );
}

/** <768：手机布局 */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.tablet - 1}px)`);
}

/** 当前布局档位：desktop（≥1280）/ tablet（768–1279）/ mobile（<768） */
export function useLayout(): import("./tokens").Layout {
  const desktop = useMediaQuery(`(min-width: ${BREAKPOINTS.desktop}px)`, true);
  const tablet = useMediaQuery(`(min-width: ${BREAKPOINTS.tablet}px)`, true);
  return desktop ? "desktop" : tablet ? "tablet" : "mobile";
}
